import { graphql } from "react-relay";

export const planStatusRefetchFragments = {
  org: graphql`
    fragment PlanStatusRefetch_org on Org {
      id

      orgAccountingPeriod {
        __typename
        ... on OrgAccountingPeriod {
          periodRange {
            minDate
            maxDate
          }
          quotaMax
          quotaUsed
          enforcementState
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }

      featureGrid {
        __typename
        ... on FeatureGrid {
          featureStates {
            quotaStatusBanner
            quotaAutopilotStatusCallout
            mixedFreemiumOrgUIState {
              quotaStatusBanner
              autopilotPaused
              moveRangesEnabled
              paymentStatusBadge {
                text
                type
              }
            }
            meetingReliefSettingVisibility
          }
          stateMetadata {
            primaryBillingGroupMetadata {
              subscription {
                id
                type
                productType
              }
            }
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
};

export const query = graphql`
  query PlanStatusRefetchQuery($orgRelayId: ID!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        ...PlanStatusRefetch_org
      }
    }
  }
`;
